module.exports = __webpack_public_path__ + "static/media/usa-anli4.b3af4c60.jpg";